/* ===========================================================================
   MAVELY JEV AD  v1   (MV122)  \u2014  "we analyse every deal with AI"
   ===========================================================================
   1. THE AI BANNER, above the three columns of the home page, in the same
      place as the Giveaway banner. When both are switched on they take turns
      there every N seconds (the "Switch between" setting in the Giveaway
      Banner panel), sliding in one after the other. Everyone sees the same
      one at the same moment: the turn is taken from the clock.

   2. THE AI AD IN THE ADVERTISEMENT SLOTS of the short-link page: laid over
      the slot's own ad (custom image, AdSense or Yandex), taking turns with
      it on the same timer. The slot's own ad is never removed, only covered
      while it is the AI ad's turn.

   Both follow the site's language (English, \u0627\u0644\u0639\u0631\u0628\u064a\u0629 right to left, Espa\u00f1ol,
   Fran\u00e7ais) live, like the Giveaway banner.

   Loaded only when index.php adds it (api/_jev_lib.php jev_ad_shell_inject,
   while one of the two is switched on), with its settings in
   window.__mvJevAdCfg. Without them (the dashboard loads it for the
   previews) it only exposes window.MavelyJevAd.

   Nothing of the Giveaway banner's own code is touched: while it is the AI
   banner's turn, the Giveaway banner is hidden with one CSS class on <html>.

   Console: __mvJevAd()
   =========================================================================== */
(function () {
  'use strict';

  if (window.MavelyJevAd && window.MavelyJevAd.version) return;

  var CFG = (window.__mvJevAdCfg && typeof window.__mvJevAdCfg === 'object') ? window.__mvJevAdCfg : null;
  var reduce = !!(window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches);
  var stats = { banner: 0, slots: 0, turns: 0 };
  var SAMPLES = [92, 70, 10];

  var EN = {
    tag: 'AI DEAL SCORE', main: 'We use advanced AI to analyze every deal',
    sub: 'Each deal gets a Success Score from 0 to 100, so you share the deals that bring the best results and the highest commissions.',
    cta: 'See top deals', score: 'Score', dir: 'ltr'
  };

  function store(k) { try { return window.localStorage.getItem(k); } catch (e) { return null; } }
  function siteLang() {
    var h = String(document.documentElement.getAttribute('lang') || '').toLowerCase().slice(0, 2);
    if (h === 'es' || h === 'fr') return h;
    var m = store('mv_lang');
    if (m === 'es' || m === 'fr') return m;
    if (h === 'ar') return 'ar';
    var s = store('sh_lang');
    if (s === 'ar' || s === 'en') return s;
    return /^ar\b/i.test(navigator.language || '') ? 'ar' : 'en';
  }
  function words(texts, l) {
    var t = (texts && texts[l]) || {}, en = (texts && texts.en) || {}, out = {};
    for (var k in EN) {
      if (!Object.prototype.hasOwnProperty.call(EN, k) || k === 'dir') continue;
      var v = t[k];
      if (v === undefined || v === null || String(v).trim() === '') v = en[k];
      if (v === undefined || v === null || String(v).trim() === '') v = EN[k];
      out[k] = String(v);
    }
    out.dir = l === 'ar' ? 'rtl' : 'ltr';
    return out;
  }

  function el(tag, cls, text) {
    var n = document.createElement(tag);
    if (cls) n.className = cls;
    if (text !== undefined && text !== null) n.textContent = text;
    return n;
  }

  /* ============================================================== styles == */

  function styles() {
    if (document.getElementById('mvjvad-css')) return;
    try { if (window.CSS && CSS.registerProperty) CSS.registerProperty({ name: '--mvjvad-f', syntax: '<percentage>', inherits: false, initialValue: '0%' }); } catch (e) {}
    var css = [
      '.mvjvad-banner{--ink:#e7f6ff;--sub:#a9c4dd;--teal:#2dd4bf;--blue:#3b82f6;--red:#f0262b;--green:#1fd15b;',
      'position:relative;margin:0 0 18px;border-radius:22px;overflow:hidden;color:var(--ink);font-family:inherit;',
      /* as tall as the Giveaway banner it takes turns with (measured), so
         nothing below moves when they switch */
      'display:flex;align-items:center;min-height:var(--mvjvad-h,0px);',
      'background:radial-gradient(120% 140% at 0% 0%,#14326b 0%,#0b1636 45%,#070d22 100%);',
      'box-shadow:0 18px 40px -18px rgba(8,17,45,.65),inset 0 0 0 1px rgba(125,211,252,.18);isolation:isolate}',
      '.mvjvad-banner::before{content:"";position:absolute;inset:0;z-index:-1;opacity:.35;',
      'background-image:linear-gradient(rgba(125,211,252,.12) 1px,transparent 1px),linear-gradient(90deg,rgba(125,211,252,.12) 1px,transparent 1px);',
      'background-size:26px 26px;mask-image:linear-gradient(90deg,#000 0%,transparent 70%);-webkit-mask-image:linear-gradient(90deg,#000 0%,transparent 70%)}',
      '.mvjvad-in{width:100%;display:grid;grid-template-columns:auto minmax(0,1fr) minmax(200px,270px);align-items:center;gap:18px;padding:12px 22px}',
      '.mvjvad-gauge{position:relative;width:84px;height:84px;flex:0 0 auto}',
      '.mvjvad-head{display:flex;flex-wrap:wrap;align-items:center;gap:8px 10px}',
      '.mvjvad-gauge svg{width:100%;height:100%;transform:rotate(-90deg)}',
      '.mvjvad-gauge .tr{fill:none;stroke:rgba(148,163,184,.22);stroke-width:9}',
      '.mvjvad-gauge .vl{fill:none;stroke:url(#mvjvadG);stroke-width:9;stroke-linecap:round;stroke-dasharray:264;stroke-dashoffset:264;',
      'transition:stroke-dashoffset 1.6s cubic-bezier(.22,.8,.28,1)}',
      '.mvjvad-gnum{position:absolute;inset:0;display:flex;flex-direction:column;align-items:center;justify-content:center;line-height:1}',
      '.mvjvad-gnum b{font-size:27px;font-weight:900;font-variant-numeric:tabular-nums;color:#fff}',
      '.mvjvad-gnum i{font-style:normal;font-size:10.5px;font-weight:800;color:var(--green);margin-top:3px;letter-spacing:.04em}',
      '.mvjvad-ai{position:absolute;top:-6px;inset-inline-end:-8px;padding:3px 7px;border-radius:8px;font-size:11px;font-weight:900;',
      'color:#04121f;background:linear-gradient(135deg,#5eead4,#60a5fa);box-shadow:0 4px 12px rgba(45,212,191,.45)}',
      '.mvjvad-tag{display:inline-flex;align-items:center;gap:6px;padding:4px 10px;border-radius:999px;font-size:11px;font-weight:900;',
      'letter-spacing:.08em;color:#99f6e4;background:rgba(45,212,191,.12);border:1px solid rgba(45,212,191,.35)}',
      '.mvjvad-tag::before{content:"";width:7px;height:7px;border-radius:50%;background:var(--teal);box-shadow:0 0 0 0 rgba(45,212,191,.7);animation:mvjvadPing 1.8s infinite}',
      '@keyframes mvjvadPing{0%{box-shadow:0 0 0 0 rgba(45,212,191,.7)}80%,100%{box-shadow:0 0 0 7px rgba(45,212,191,0)}}',
      '.mvjvad-main{margin:5px 0 2px;font-size:clamp(17px,1.85vw,25px);font-weight:900;line-height:1.12;letter-spacing:-.01em;color:#fff}',
      '.mvjvad-main em{font-style:normal;background:linear-gradient(90deg,#5eead4,#60a5fa);-webkit-background-clip:text;background-clip:text;color:transparent}',
      '.mvjvad-sub{margin:0;font-size:clamp(12px,.95vw,13px);line-height:1.35;color:var(--sub);max-width:none;',
      'display:-webkit-box;-webkit-line-clamp:2;-webkit-box-orient:vertical;overflow:hidden}',
      '.mvjvad-bars{display:flex;flex-direction:column;gap:5px}',
      '.mvjvad-bar{--mvjvad-f:0%;display:flex;align-items:center;gap:8px;height:23px;padding:0 5px;border-radius:8px;',
      'background:linear-gradient(var(--mvjvad-dir,90deg),var(--red) 0%,var(--red) calc(100% - var(--mvjvad-f) - 8%),var(--green) calc(100% - var(--mvjvad-f) + 8%),var(--green) 100%);',
      'box-shadow:inset 0 0 0 1px rgba(255,255,255,.18);transition:--mvjvad-f 1.5s cubic-bezier(.22,.8,.28,1)}',
      '.mvjvad-bar .ln{flex:1 1 auto;height:8px;border-radius:5px;background:rgba(255,255,255,.85);max-width:58%}',
      '.mvjvad-bar .ln.s{max-width:38%}',
      '.mvjvad-bar b{margin-inline-start:auto;min-width:44px;text-align:center;padding:1px 6px;border-radius:6px;font-size:12px;font-weight:900;',
      'color:#071018;background:rgba(255,255,255,.72);font-variant-numeric:tabular-nums}',
      '.mvjvad-cta{display:inline-flex;align-items:center;justify-content:center;gap:6px;padding:5px 12px;border-radius:999px;',
      'font-size:12.5px;font-weight:900;color:#04121f;text-decoration:none;background:linear-gradient(135deg,#5eead4,#22c55e);',
      'box-shadow:0 8px 18px -8px rgba(34,197,94,.7)}',
      '.mvjvad-cta:hover{filter:brightness(1.08)}',
      '.mvjvad-banner .mvjvad-cta{font-size:12px}',
      '.mvjvad-shine{position:absolute;inset:0;pointer-events:none;overflow:hidden;border-radius:inherit;z-index:2}',
      '.mvjvad-shine::after{content:"";position:absolute;top:0;bottom:0;left:0;width:40%;transform:translateX(-120%) skewX(-18deg);',
      'background:linear-gradient(90deg,transparent,rgba(255,255,255,.14),transparent);animation:mvjvadShine 5.5s ease-in-out infinite}',
      '@keyframes mvjvadShine{0%,55%{transform:translateX(-120%) skewX(-18deg)}100%{transform:translateX(320%) skewX(-18deg)}}',
      '.mvjvad-banner[dir=rtl],.mvjvad-slot[dir=rtl]{--mvjvad-dir:270deg}',
      '.mvjvad-still .mvjvad-shine::after,.mvjvad-still .mvjvad-tag::before{animation-play-state:paused}',
      /* below 1180px the sample bars give their room to the words, so the
         banner stays as low as the Giveaway banner */
      '@media (max-width:1180px){.mvjvad-in{grid-template-columns:auto minmax(0,1fr)}.mvjvad-banner .mvjvad-side{display:none}}',
      '@media (max-width:900px){.mvjvad-in{gap:14px;padding:12px 16px}}',
      '@media (max-width:520px){.mvjvad-banner .mvjvad-gauge{width:64px;height:64px}.mvjvad-banner .mvjvad-gnum b{font-size:20px}',
      '.mvjvad-banner .mvjvad-gnum i{font-size:9px}.mvjvad-banner{border-radius:16px}.mvjvad-in{gap:12px;padding:10px 12px}',
      '.mvjvad-banner .mvjvad-sub{-webkit-line-clamp:4}}',
      /* taking turns with the Giveaway banner */
      '@keyframes mvjvadIn{from{opacity:0;transform:translateY(10px) scale(.985)}to{opacity:1;transform:none}}',
      'html.mvjvad-turn-ai .mv-rd-hero-in>.mvgw-banner{display:none!important}',
      'html.mvjvad-turn-gw .mv-rd-hero-in>.mvjvad-banner{display:none!important}',
      'html.mvjvad-anim .mv-rd-hero-in>.mvgw-banner,html.mvjvad-anim .mv-rd-hero-in>.mvjvad-banner{animation:mvjvadIn .55s cubic-bezier(.22,.8,.28,1) both}',
      /* the Advertisement Slot */
      '.mvjvad-slot{--red:#f0262b;--green:#1fd15b;position:absolute;inset:34px 16px 16px;z-index:5;display:flex;flex-direction:column;',
      'align-items:center;justify-content:space-between;gap:10px;padding:18px 16px;border-radius:18px;text-align:center;color:#e7f6ff;overflow:hidden;',
      'background:radial-gradient(130% 90% at 50% 0%,#17407f 0%,#0b1636 50%,#070d22 100%);box-shadow:inset 0 0 0 1px rgba(125,211,252,.2)}',
      '.mvjvad-slot.is-off{display:none}',
      '.mvjvad-slot.is-in{animation:mvjvadIn .55s cubic-bezier(.22,.8,.28,1) both}',
      '.mvjvad-slot .mvjvad-gauge{width:120px;height:120px}',
      '.mvjvad-slot .mvjvad-gnum b{font-size:36px}',
      '.mvjvad-slot .mvjvad-main{font-size:22px;margin:4px 0}',
      '.mvjvad-slot .mvjvad-sub{font-size:13px}',
      '.mvjvad-slot .mvjvad-bars{width:100%}',
      '.mvjvad-slot .mvjvad-cta{width:100%;padding:11px 14px;font-size:14px;border-radius:12px}',
      '.mvjvad-slot .mvjvad-bar{height:28px}',
      '.mvjvad-slot .mvjvad-sub{-webkit-line-clamp:5}',
      '.mvjvad-preview{position:relative;height:100%}',
      '.mvjvad-preview .mvjvad-slot{inset:0}',
      '@media (prefers-reduced-motion:reduce){.mvjvad-bar,.mvjvad-gauge .vl{transition:none}.mvjvad-shine::after,.mvjvad-tag::before{animation:none}',
      'html.mvjvad-anim .mv-rd-hero-in>.mvgw-banner,html.mvjvad-anim .mv-rd-hero-in>.mvjvad-banner,.mvjvad-slot.is-in{animation:none}}'
    ].join('');
    var st = document.createElement('style');
    st.id = 'mvjvad-css';
    st.textContent = css;
    (document.head || document.documentElement).appendChild(st);
  }

  /* ============================================================== pieces == */

  var gid = 0;
  function gauge(scoreWord) {
    var g = el('div', 'mvjvad-gauge');
    var id = 'mvjvadG' + (++gid);
    g.innerHTML = '<svg viewBox="0 0 100 100" aria-hidden="true" focusable="false"><defs><linearGradient id="' + id + '" x1="0" y1="0" x2="1" y2="0">' +
      '<stop offset="0" stop-color="#f0262b"/><stop offset=".5" stop-color="#f59e0b"/><stop offset="1" stop-color="#1fd15b"/></linearGradient></defs>' +
      '<circle class="tr" cx="50" cy="50" r="42"/><circle class="vl" cx="50" cy="50" r="42" style="stroke:url(#' + id + ')"/></svg>';
    var n = el('div', 'mvjvad-gnum');
    n.appendChild(el('b', null, '0'));
    n.appendChild(el('i', null, scoreWord));
    g.appendChild(n);
    g.appendChild(el('span', 'mvjvad-ai', 'AI'));
    return g;
  }

  function bars() {
    var b = el('div', 'mvjvad-bars');
    b.setAttribute('aria-hidden', 'true');
    for (var i = 0; i < SAMPLES.length; i++) {
      var r = el('div', 'mvjvad-bar');
      r.setAttribute('data-s', String(SAMPLES[i]));
      r.appendChild(el('span', 'ln' + (i === 1 ? ' s' : '')));
      r.appendChild(el('b', null, '( ' + SAMPLES[i] + ' )'));
      b.appendChild(r);
    }
    return b;
  }

  /** The headline with its last two words in the gradient ("every deal"). */
  function headline(node, text) {
    node.textContent = '';
    var w = String(text || '').split(' ');
    if (w.length < 4) { node.textContent = text; return; }
    node.appendChild(document.createTextNode(w.slice(0, -2).join(' ') + ' '));
    node.appendChild(el('em', null, w.slice(-2).join(' ')));
  }

  /** Count the gauge up and fill the bars: once per appearance. */
  function play(root) {
    if (!root) return;
    var vl = root.querySelector('.mvjvad-gauge .vl'), num = root.querySelector('.mvjvad-gnum b');
    var target = 92;
    var barsEls = root.querySelectorAll('.mvjvad-bar');
    var reset = function () {
      if (vl) { vl.style.transition = 'none'; vl.style.strokeDashoffset = '264'; void vl.getBoundingClientRect(); vl.style.transition = ''; }
      for (var i = 0; i < barsEls.length; i++) { barsEls[i].style.transition = 'none'; barsEls[i].style.setProperty('--mvjvad-f', '0%'); void barsEls[i].offsetWidth; barsEls[i].style.transition = ''; }
      if (num) num.textContent = '0';
    };
    var go = function () {
      if (vl) vl.style.strokeDashoffset = String(264 - 264 * target / 100);
      for (var i = 0; i < barsEls.length; i++) barsEls[i].style.setProperty('--mvjvad-f', barsEls[i].getAttribute('data-s') + '%');
      if (!num) return;
      if (reduce) { num.textContent = String(target); return; }
      var t0 = performance.now(), dur = 1500;
      (function tick(now) {
        var k = Math.min(1, (now - t0) / dur);
        var e = 1 - Math.pow(1 - k, 3);
        num.textContent = String(Math.round(target * e));
        if (k < 1) requestAnimationFrame(tick);
      })(t0);
    };
    reset();
    requestAnimationFrame(function () { requestAnimationFrame(go); });
  }

  /** "See top deals": on a page with the Deals List, scroll to it; anywhere
      else the link simply opens the home page. */
  function toDeals(e) {
    var img = document.querySelector('img[alt="Deal product"]');
    if (!img) return;
    e.preventDefault();
    try { img.scrollIntoView({ behavior: reduce ? 'auto' : 'smooth', block: 'center' }); } catch (x) { img.scrollIntoView(); }
  }

  function buildBanner(t, l) {
    var root = el('div', 'mvjvad-banner');
    root.setAttribute('role', 'region');
    root.setAttribute('data-no-i18n', '1');
    root.setAttribute('translate', 'no');
    var inr = el('div', 'mvjvad-in');
    inr.appendChild(gauge(t.score));
    var mid = el('div', 'mvjvad-mid');
    var head = el('div', 'mvjvad-head');
    head.appendChild(el('span', 'mvjvad-tag', t.tag));
    mid.appendChild(head);
    var h = el('p', 'mvjvad-main');
    mid.appendChild(h);
    mid.appendChild(el('p', 'mvjvad-sub', t.sub));
    inr.appendChild(mid);
    var side = el('div', 'mvjvad-side');
    side.appendChild(bars());
    var cta = el('a', 'mvjvad-cta', t.cta + (t.dir === 'rtl' ? '  \u2190' : '  \u2192'));
    cta.href = (CFG && CFG.home) || '/';
    cta.addEventListener('click', toDeals);
    head.appendChild(cta);
    inr.appendChild(side);
    root.appendChild(inr);
    root.appendChild(el('span', 'mvjvad-shine'));
    paintTexts(root, t, l);
    return root;
  }

  function paintTexts(root, t, l) {
    root.setAttribute('lang', l);
    root.setAttribute('dir', t.dir);
    root.setAttribute('aria-label', t.tag + ' \u2014 ' + t.main);
    var q = function (s) { return root.querySelector(s); };
    if (q('.mvjvad-tag')) q('.mvjvad-tag').textContent = t.tag;
    if (q('.mvjvad-main')) headline(q('.mvjvad-main'), t.main);
    if (q('.mvjvad-sub')) q('.mvjvad-sub').textContent = t.sub;
    if (q('.mvjvad-gnum i')) q('.mvjvad-gnum i').textContent = t.score;
    if (q('.mvjvad-cta')) q('.mvjvad-cta').textContent = t.cta + (t.dir === 'rtl' ? '  \u2190' : '  \u2192');
  }

  function buildSlot(t, l) {
    var root = el('div', 'mvjvad-slot');
    root.setAttribute('data-no-i18n', '1');
    root.setAttribute('translate', 'no');
    root.appendChild(el('span', 'mvjvad-tag', t.tag));
    root.appendChild(gauge(t.score));
    var h = el('p', 'mvjvad-main');
    root.appendChild(h);
    root.appendChild(bars());
    root.appendChild(el('p', 'mvjvad-sub', t.sub));
    var cta = el('a', 'mvjvad-cta', t.cta);
    cta.href = (CFG && CFG.home) || '/';
    cta.addEventListener('click', toDeals);
    root.appendChild(cta);
    root.appendChild(el('span', 'mvjvad-shine'));
    paintTexts(root, t, l);
    return root;
  }

  /* ======================================================= taking turns == */

  function rotateMs() { return CFG ? Math.max(0, (+CFG.rotate || 0) * 1000) : 0; }
  /** 0 = the other ad's turn, 1 = the AI's turn. From the clock, so every
      visitor and every slot agree, and a reload keeps the same turn. */
  function turn() {
    var ms = rotateMs();
    if (!ms) return 1;
    return Math.floor(Date.now() / ms) % 2 === 1 ? 1 : 0;
  }

  var bannerEl = null, bannerLang = '', lastTurn = -1;

  function bannerPlaced() {
    var p = bannerEl && bannerEl.parentNode;
    if (!p || !p.classList || !p.classList.contains('mv-rd-hero-in')) return false;
    var prev = bannerEl.previousElementSibling;
    return p.firstElementChild === bannerEl || !!(prev && prev.classList && prev.classList.contains('mvgw-banner') && prev.previousElementSibling === null);
  }

  /** Just after the Giveaway banner, or first when there is none \u2014 never in
      front of it, so its own "am I first?" check is never upset. */
  function mountBanner() {
    if (!CFG || !CFG.banner) return;
    var host = document.querySelector('.mv-rd-hero-in');
    if (!host) return;
    var l = siteLang();
    if (!bannerEl) { bannerEl = buildBanner(words(CFG.t, l), l); bannerLang = l; }
    if (!bannerPlaced()) {
      var first = host.firstElementChild;
      if (first && first.classList.contains('mvgw-banner')) host.insertBefore(bannerEl, first.nextSibling);
      else host.insertBefore(bannerEl, host.firstChild);
      stats.banner++;
      watchInView(bannerEl);
      if (bannerVisible()) play(bannerEl);
    }
  }

  function bannerVisible() { return !document.documentElement.classList.contains('mvjvad-turn-gw'); }

  /** Which banner is up. Only takes turns while the Giveaway banner is really
      on the page; otherwise the AI banner simply stays. */
  /** The Giveaway banner's height while it is on screen, kept in --mvjvad-h
      so the AI banner takes exactly its place. */
  function measureGw() {
    var gw = document.querySelector('.mv-rd-hero-in>.mvgw-banner');
    if (!gw || !gw.offsetHeight) return;
    var h = gw.offsetHeight + 'px';
    var root = document.documentElement;
    if (root.style.getPropertyValue('--mvjvad-h') !== h) root.style.setProperty('--mvjvad-h', h);
    try { window.localStorage.setItem('mvjvad_h', window.innerWidth + ':' + gw.offsetHeight); } catch (e) {}
  }

  /** The height measured on an earlier visit at this width, so the very
      first AI turn is already the right size. */
  function rememberedHeight() {
    var v = store('mvjvad_h');
    var m = v && /^(\d+):(\d+)$/.exec(v);
    if (!m || Math.abs(+m[1] - window.innerWidth) > 40) return;
    document.documentElement.style.setProperty('--mvjvad-h', m[2] + 'px');
  }

  function applyTurn(animate) {
    var html = document.documentElement;
    try { measureGw(); } catch (e) {}
    var gwHere = !!document.querySelector('.mv-rd-hero-in>.mvgw-banner');
    var both = CFG && CFG.banner && gwHere && rotateMs() > 0;
    var t = both ? turn() : 1;
    var cls = !both ? '' : (t === 1 ? 'mvjvad-turn-ai' : 'mvjvad-turn-gw');
    html.classList.remove(cls === 'mvjvad-turn-ai' ? 'mvjvad-turn-gw' : 'mvjvad-turn-ai');
    if (cls) html.classList.add(cls); else { html.classList.remove('mvjvad-turn-ai'); html.classList.remove('mvjvad-turn-gw'); }
    if (t !== lastTurn) {
      if (lastTurn !== -1 && animate) {
        html.classList.remove('mvjvad-anim');
        void html.offsetWidth;
        html.classList.add('mvjvad-anim');
        stats.turns++;
      }
      if (t === 1 && bannerEl) play(bannerEl);
      lastTurn = t;
    }
    paintSlots(animate);
  }

  /* ========================================================= the slots == */

  var SLOT_WORDS = /^(advertisement slot|espacio publicitario|emplacement publicitaire|\u0645\u0633\u0627\u062d\u0629 \u0625\u0639\u0644\u0627\u0646\u064a\u0629)$/i;
  var slotEls = [];

  function findSlots() {
    var out = [];
    var spans = document.querySelectorAll('.glass-card > span');
    for (var i = 0; i < spans.length; i++) {
      if (SLOT_WORDS.test((spans[i].textContent || '').trim())) out.push(spans[i].parentElement);
    }
    return out;
  }

  function mountSlots() {
    if (!CFG || !CFG.slots) return;
    var cards = findSlots();
    for (var i = 0; i < cards.length; i++) {
      var card = cards[i];
      if (card.querySelector(':scope > .mvjvad-slot')) continue;
      if (getComputedStyle(card).position === 'static') card.style.position = 'relative';
      var l = siteLang();
      var s = buildSlot(words(CFG.t, l), l);
      s.__lang = l;
      card.appendChild(s);
      slotEls.push(s);
      stats.slots++;
      watchInView(s);
    }
    paintSlots(false);
  }

  function paintSlots(animate) {
    var on = turn() === 1;
    for (var i = slotEls.length - 1; i >= 0; i--) {
      var s = slotEls[i];
      if (!s.isConnected) { slotEls.splice(i, 1); continue; }
      var wasOff = s.classList.contains('is-off');
      if (on) {
        s.classList.remove('is-off');
        if (wasOff || !s.__played) {
          s.__played = true;
          if (animate) { s.classList.remove('is-in'); void s.offsetWidth; s.classList.add('is-in'); }
          play(s);
        }
      } else {
        s.classList.add('is-off');
      }
    }
  }

  /* ========================================================== the rest == */

  var viewIO = null;
  function watchInView(node) {
    if (!window.IntersectionObserver) return;
    if (!viewIO) viewIO = new IntersectionObserver(function (list) {
      for (var i = 0; i < list.length; i++) list[i].target.classList.toggle('mvjvad-still', !list[i].isIntersecting);
    });
    try { viewIO.observe(node); } catch (e) {}
  }

  function relang() {
    var l = siteLang();
    if (bannerEl && l !== bannerLang) { bannerLang = l; paintTexts(bannerEl, words(CFG.t, l), l); }
    for (var i = 0; i < slotEls.length; i++) {
      if (slotEls[i].__lang !== l) { slotEls[i].__lang = l; paintTexts(slotEls[i], words(CFG.t, l), l); }
    }
  }

  var due = null;
  function schedule() {
    if (due) return;
    due = setTimeout(function () {
      due = null;
      try { mountBanner(); } catch (e) {}
      try { mountSlots(); } catch (e) {}
      try { applyTurn(false); } catch (e) {}
    }, 60);
  }

  function boot() {
    styles();
    /* Decided before the app paints, so on the AI banner's turn the Giveaway
       banner never flashes up first. Checked again once both are there. */
    if (CFG.banner && CFG.gw && rotateMs() > 0) {
      document.documentElement.classList.add(turn() === 1 ? 'mvjvad-turn-ai' : 'mvjvad-turn-gw');
      lastTurn = turn();
      rememberedHeight();
    }
    schedule();
    if (window.MutationObserver) {
      new MutationObserver(function (recs) {
        /* the banner goes in in the same frame the hero is drawn (no jump) */
        if (CFG.banner && !bannerPlaced()) { try { mountBanner(); } catch (e) {} }
        for (var i = 0; i < recs.length; i++) {
          if (recs[i].type === 'attributes') { relang(); continue; }
          for (var n = 0; n < recs[i].addedNodes.length; n++) {
            var node = recs[i].addedNodes[n];
            if (node.nodeType !== 1) continue;
            var c = typeof node.className === 'string' ? node.className : '';
            if (c.indexOf('mvjvad-') === 0) continue;
            schedule();
            return;
          }
        }
      }).observe(document.documentElement, { childList: true, subtree: true, attributes: true, attributeFilter: ['lang'] });
    }
    var ms = rotateMs();
    if (ms) {
      // wake exactly at the next turn, then every turn
      var wait = ms - (Date.now() % ms) + 30;
      setTimeout(function () {
        applyTurn(true);
        setInterval(function () { applyTurn(true); }, ms);
      }, wait);
    }
    window.addEventListener('storage', relang);
    var rz = null;
    window.addEventListener('resize', function () {
      if (rz) return;
      rz = setTimeout(function () {
        rz = null;
        /* a new width can mean a new height: measure it while it is shown */
        var root = document.documentElement;
        if (root.classList.contains('mvjvad-turn-ai')) root.style.removeProperty('--mvjvad-h');
        try { measureGw(); } catch (e) {}
      }, 200);
    });
  }

  window.MavelyJevAd = {
    version: 1,
    words: words,
    /** Previews in the dashboard: a banner / a slot inside `host`. */
    renderBanner: function (host, t, l) {
      styles();
      var w = words({ en: t }, 'en');
      w.dir = l === 'ar' ? 'rtl' : 'ltr';
      var b = buildBanner(w, l || 'en');
      host.textContent = '';
      host.appendChild(b);
      play(b);
      return b;
    },
    renderSlot: function (host, t, l) {
      styles();
      var wrap = el('div', 'mvjvad-preview');
      var w = words({ en: t }, 'en');
      w.dir = l === 'ar' ? 'rtl' : 'ltr';
      var s = buildSlot(w, l || 'en');
      wrap.appendChild(s);
      host.textContent = '';
      host.appendChild(wrap);
      play(s);
      return s;
    }
  };

  window.__mvJevAd = function () {
    return { version: 1, cfg: CFG, turn: turn(), rotateSec: rotateMs() / 1000, stats: stats, slots: slotEls.length };
  };

  if (!CFG) return;
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot, { once: true });
  else boot();
})();
